(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        'use strict';

        var initSaleCountryImages = function initSaleCountryImages(root) {
            root.querySelectorAll('.sale-country__image[data-fallback-src]').forEach(function (image) {
                var showPlaceholder = function showPlaceholder() {
                    image.removeEventListener('error', showPlaceholder);
                    image.src = image.dataset.fallbackSrc;
                    image.alt = image.dataset.fallbackAlt;
                };
                image.addEventListener('error', showPlaceholder, { once: true });
                if (image.complete && image.naturalWidth === 0) showPlaceholder();
            });
        };

        var initHotOffersControls = function initHotOffersControls(root) {
            root.querySelectorAll('.sale-hot-offers').forEach(function (block) {
                var track = block.querySelector('.swiper-wrapper');
                var previous = block.querySelector('[data-direction="-1"]');
                var next = block.querySelector('[data-direction="1"]');
                if (!previous || !next) return;
                var update = function update() {
                    previous.disabled = track.scrollLeft <= 1;
                    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
                };
                track.addEventListener('scroll', update, { passive: true });
                block.querySelectorAll('.sale-hot-offers__arrow').forEach(function (button) {
                    button.addEventListener('click', function () {
                        track.scrollBy({ left: Number(button.dataset.direction) * track.clientWidth, behavior: 'smooth' });
                    });
                });
                update();
            });
        };

        var initSalePage = function initSalePage() {
            var page = document.querySelector('.sale-page');
            if (!page) return;
            var panel = page.querySelector('.sale-page__panel');
            var error = page.querySelector('.sale-page__tab-error');
            var tabs = Array.from(page.querySelectorAll('[role="tab"]'));
            var selected = tabs.find(function (tab) {
                return tab.getAttribute('aria-selected') === 'true';
            });
            var cache = new Map([[selected.dataset.url, panel.innerHTML]]);
            var request = null;
            var version = 0;

            var initContent = function initContent() {
                initSaleCountryImages(panel);
                initHotOffersControls(panel);
            };
            var markSelected = function markSelected(tab) {
                tabs.forEach(function (item) {
                    var active = item === tab;
                    item.classList.toggle('is-active', active);
                    item.setAttribute('aria-selected', String(active));
                    item.tabIndex = active ? 0 : -1;
                });
            };
            var activate = function activate(tab) {
                if (tab === selected && !request) return;
                var currentVersion = ++version;
                if (request) request.abort();
                request = new AbortController();
                markSelected(tab);
                error.hidden = true;
                panel.setAttribute('aria-busy', 'true');
                panel.classList.add('is-loading');
                panel.querySelector('.hot-offers-loader').classList.add('is-active');
                var cached = cache.get(tab.dataset.url);
                var content = cached !== undefined ? Promise.resolve(cached) : fetch(tab.dataset.url, {
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },
                    signal: request.signal
                }).then(function (response) {
                    if (!response.ok) throw new Error('Unable to load city');
                    return response.text();
                });
                content.then(function (html) {
                    if (version !== currentVersion) return;
                    cache.set(tab.dataset.url, html);
                    panel.innerHTML = html;
                    panel.setAttribute('aria-labelledby', tab.id);
                    selected = tab;
                    initContent();
                }).catch(function (failure) {
                    if (version !== currentVersion || failure.name === 'AbortError') return;
                    markSelected(selected);
                    error.textContent = page.dataset.tabError;
                    error.hidden = false;
                }).finally(function () {
                    if (version === currentVersion) {
                        request = null;
                        panel.removeAttribute('aria-busy');
                        panel.classList.remove('is-loading');
                        panel.querySelector('.hot-offers-loader').classList.remove('is-active');
                    }
                });
            };
            tabs.forEach(function (tab, index) {
                tab.addEventListener('click', function () {
                    return activate(tab);
                });
                tab.addEventListener('keydown', function (event) {
                    var next = void 0;
                    if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
                    if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
                    if (event.key === 'Home') next = 0;
                    if (event.key === 'End') next = tabs.length - 1;
                    if (next === undefined) return;
                    event.preventDefault();
                    tabs[next].focus();
                    activate(tabs[next]);
                });
            });
            initContent();
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initSalePage, { once: true });
        } else {
            initSalePage();
        }

        document.addEventListener('click', function (event) {
            var card = event.target.closest('.sale-hot-offers .js-offer-of-day-card');
            if (card && !event.target.closest('a')) window.location.href = card.dataset.url;
        });
    }, {}] }, {}, [1]);